import { FC } from 'react';
import { Spacing } from '../../atoms/spacing/spacing';
import { Typography } from '../../atoms/typography/typography';
import { List } from '@taleemabad/dsm/components';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import styled from '@emotion/styled';

const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--rk-spacing-xl);
  ${mq(BreakpointSizes.xs)} {
    grid-template-columns: repeat(1, 1fr);
    row-gap: var(--rk-spacing-md);
  }
  margin-top: var(--rk-spacing-md);
`;

interface UserRole {
  id?: number;
  name?: string;
  role?: string;
}
interface UserRoleSelectionProps {
  profiles: UserRole[];
  onRoleSelected: (data: UserRole) => void;
}

export const UserRoleSelection: FC<UserRoleSelectionProps> = ({
  profiles,
  onRoleSelected,
}) => {
  return (
    <Spacing marginBottom="xxxl">
      <Typography variant="textTitleLarge">Welcome to NIETE</Typography>
      <Spacing marginBottom="xl" />
      <Typography variant="textBodyLarge">Select your role</Typography>
      <Spacing marginBottom="xl" />
      {profiles.map((profile) => (
        <ListContainer key={profile.id}>
          <List
            key={profile.id}
            alignment="center"
            heading={profile.role || ''}
            leadingIcon={{
              direction: 'leading',
              source: 'more_vert',
              name: profile.role,
              type: 'monogram',
              isUpperCase: true,
            }}
            trailingIcon={{
              direction: 'trailing',
              source: 'keyboard_arrow_right',
              name: 'keyboard_arrow_right',
              type: 'icon',
            }}
            onClick={() => {
              onRoleSelected?.(profile);
            }}
          />
        </ListContainer>
      ))}
    </Spacing>
  );
};
